<template lang="pug">
div
  .row
    .col-md-8.col-md-offset-2
      .jumbotron(:class="{'danger' : ($store.state.config.versionBackend && $store.waveVersion) && $store.state.config.versionBackend !== $store.waveVersion}")
        h1 {{$options.filters.translate("Welcome to JOY Agent", lang)}} {{this.$store.state.config.versionBackend}}/{{this.$store.waveVersion}}!
        p {{$options.filters.translate("Logged user", lang)}}: {{this.$store.getters.user.nick}}
        h2(v-if="$store.state.config.versionBackend && $store.waveVersion && $store.state.config.versionBackend !== $store.waveVersion") {{$options.filters.translate("Please reload browser", lang)}}!
</template>

<script>
export default {
  name: 'home',
  props: ['lang'],
  created () {
    const self = this
    self.$http.get('system/version')
      .then(response => {
        return response.json()
      })
      .then(data => {
        self.$store.commit('SET_CONFIG', data)
      })
  }
}
</script>
<style lang="sass" scoped>
@import "~sass/_variables"
.jumbotron.danger
  background-color: $brand-danger
</style>



// WEBPACK FOOTER //
// src/components/Home.vue